<app-header #header title="home"></app-header>

<ion-content fullscreen="true" scrollEvents="true" [appHideHeader]="header" class="ionic_background">
    <app-header-content></app-header-content>
    <app-pagecontent [path]="'/'"></app-pagecontent>

    <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>


    <ion-grid class="page-min-height" *ngIf="loaded" style="padding: 0;">
        <ion-row>
            <ion-col
                    *ngIf="dataService['settings']['violations']['appeals_enabled'] == '1'"
                    class="responsive-align"
                    size="10" offset="1" sizeSm="12"
            >
                <h3 class="subheader-regular">
                    {{('keys.data.violations.unpaid_violations' | translate : {Default: 'Unpaid Violations'}) || 'Unpaid Violations'}}
                </h3>
            </ion-col>
        </ion-row>
        <ion-row *ngIf="unpaidViolations.length>0 && dataService['settings']['violations']['appeals_enabled'] == '1'">

            <ion-col size="10" offset="1">
                <ion-grid>

                    <ion-row class="swiper-items">
                        <ion-col
                                size-xs="11"
                                offset-xs="0.5"
                                size-sm="10"
                                offset-sm="1">
                            <swiper
                                #swiper

                                [config]="violationsConfig"
                            >
                                <ng-template *ngFor="let violation of unpaidViolations; let i = index" swiperSlide style="text-align: center">
                                    <app-violations [violation]="violation"></app-violations>


                                </ng-template>

                            </swiper>

                        </ion-col>
                    </ion-row>
                    <ion-row class="stacked-items">
                        <ion-col style="margin: 0.5em 0;padding: 1em;"
                                 size-md="6"

                                 size-xl="4" *ngFor="let violation of unpaidViolations; let i = index">
                            <app-violations [violation]="violation"></app-violations>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>

        <ion-row *ngIf="unpaidViolations.length<1 && dataService['settings']['violations']['appeals_enabled'] == '1'">
            <ion-col size="6" offset="3">
                <ion-card class="card-shadow-3">
                    <ion-card-content style="text-align: center">
                        <ion-label class="paragraph-input-fields-regular"> {{('keys.data.violations.no_active_violations' | translate : {Default: "User doesn't have any unpaid violations."}) || "User doesn't have any unpaid violations."}}</ion-label>
                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>

        <ion-row *ngIf="dataService['settings']['permits']['enabled'] == '1'">
            <ion-col
                    class="responsive-align"
                    size="10" offset="1" sizeSm="12"
            >
                <h3 class="subheader-regular">
                    {{ 'keys.data.users_menu.permits' | translate }}
                </h3>
            </ion-col>
        </ion-row>

        <ion-row *ngIf="(standardPermits.length>0 || tempPermits.length>0) && dataService['settings']['permits']['enabled'] == '1'">
            <ion-col size="10" offset="1">
                <ion-grid>

                    <ion-row class="stacked-items">
                        <ion-col style="margin: 0.5em 0;"
                                 size-md="6"
                                 size-lg="4"
                                 size-xl="3" *ngFor="let tempPermit of tempPermits">
                            <app-temppermits style="cursor: pointer;" (click)="PermitInfo(tempPermit,'temp')" [tempPermit]="tempPermit"></app-temppermits>
                        </ion-col>

                        <ion-col style="margin: 0.5em  0;" size-md="6"
                                 size-lg="4"
                                 size-xl="3"
                                 *ngFor="let standardPermit of standardPermits">
                            <app-permits style="cursor: pointer;" (click)="PermitInfo(standardPermit,'standard')" [standardPermit]="standardPermit"></app-permits>
                        </ion-col>
                    </ion-row>

                    <ion-row class="swiper-items">
                        <ion-col
                                size-xs="12"
                                size-sm="11"
                                offset-sm="0.5">
                            <swiper
                                #swiper

                                [config]="permitsConfig"
                            >
                                <ng-template *ngFor="let standardPermit of standardPermits" swiperSlide style="text-align: center">
                                    <app-permits (click)="PermitInfo(standardPermit,'standard')" [standardPermit]="standardPermit"></app-permits>

                                </ng-template>
                                <ng-template *ngFor="let tempPermit of tempPermits" swiperSlide style="text-align: center;">
                                    <app-temppermits (click)="PermitInfo(tempPermit,'temp')" [tempPermit]="tempPermit"></app-temppermits>


                                </ng-template>
                            </swiper>

                        </ion-col>

                    </ion-row>
                </ion-grid>
            </ion-col>

        </ion-row>

        <ion-row *ngIf="standardPermits.length<1 && tempPermits.length<1 && dataService['settings']['permits']['enabled'] == '1'">
            <ion-col size="6" offset="3">
                <ion-card class="card-shadow-3">
                    <ion-card-content style="text-align: center">
                        <ion-label class="paragraph-input-fields-regular"> {{('keys.data.permits.no_active_permits' | translate : {Default: "User doesn't have any active permits"}) || "User doesn't have any active permits"}}</ion-label>
                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>

        <div *ngIf="dataService.settings['permits']?.['enable_permit_waiting_list'] == true">
            <ion-row>
                <ion-col class="responsive-align" size="10" offset="1" sizeSm="12">

                    <h3 class="subheader-regular">
                        {{ ('keys.data.users_menu.waitlist' | translate : {Default: 'Waitlist'}) || "Waitlist"}}
                    </h3>
                </ion-col>
            </ion-row>

            <ion-row>
                <ion-col size="10" offset="1">
                    <ion-grid>
                        <ion-row class="stacked-items">
                            <ion-col style="margin: 0.5em 0;"
                                     size-md="6"
                                     size-lg="4"
                                     size-xl="3" *ngFor="let item of waitlist | keyvalue">

                                <app-waitlist-block [waitlist_item]="item.value"></app-waitlist-block>
                            </ion-col>
                        </ion-row>

                        <ion-row class="swiper-items">
                            <ion-col size-xs="12" size-sm="11" offset-sm="0.5">
                                <swiper #swiper [config]="permitsConfig">
                                    <ng-template *ngFor="let item of waitlist | keyvalue" swiperSlide style="text-align: center">
                                        <app-waitlist-block [waitlist_item]="item.value"></app-waitlist-block>
                                    </ng-template>
                                </swiper>

                            </ion-col>

                        </ion-row>
                    </ion-grid>
                </ion-col>
            </ion-row>

            <ng-container *ngFor="let item of waitlist | keyvalue; first as isFirst">
                <ion-row *ngIf="isFirst && item.value.rank === -1">
                    <ion-col size="6" offset="3">
                        <ion-card class="card-shadow-3">
                            <ion-card-content style="text-align: center">
                                <ion-label class="paragraph-input-fields-regular">
                                    {{('keys.data.permits.no_waitlist' | translate : {Default: "User isn't on a waitlist"}) || "User isn't on a waitlist"}}
                                </ion-label>
                            </ion-card-content>
                        </ion-card>
                    </ion-col>
                </ion-row>
            </ng-container>
        </div>

        <ion-row>
            <ion-col
                    class="responsive-align"
                    size="10" offset="1" sizeSm="12"
            >

                <h3 class="subheader-regular">
                    {{ ('keys.data.users_menu.vehicles' | translate : {Default: 'Vehicles'}) || "Vehicles"}}
                </h3>
            </ion-col>
        </ion-row>

        <ion-row *ngIf="vehiclesSRV.vehicles.length>0">
            <ion-col size="10" offset="1">

                <ion-grid>

                    <ion-row class="stacked-items">
                        <ion-col style="margin: 0.5em 0;"
                                 size-md="6"

                                 size-lg="4"
                                 size-xl="3" *ngFor="let vehicle of vehiclesSRV.vehicles">

                            <app-vehicles [vehicle]="vehicle"></app-vehicles>
                        </ion-col>
                    </ion-row>

                    <ion-row class="swiper-items">
                        <ion-col
                                size-xs="12"
                                size-sm="11"
                                offset-sm="0.5">
                            <ion-toolbar style="--background:transparent">
                                <swiper
                                    #swiper

                                    [config]="vehiclesConfig"
                                >
                                    <ng-template swiperSlide style="text-align: center" *ngFor="let vehicle of vehiclesSRV.vehicles">
                                        <app-vehicles [vehicle]="vehicle"></app-vehicles>


                                    </ng-template>
                                </swiper>
                            </ion-toolbar>
                        </ion-col>

                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>

        <ion-row *ngIf="vehiclesSRV.vehicles.length<1">
            <ion-col size="6" offset="3">
                <ion-card class="card-shadow-3">
                    <ion-card-content style="text-align: center">
                        <ion-label class="paragraph-input-fields-regular"> {{ ('keys.data.vehicles.no_user_vehicles' | translate : {Default: 'User has no associated vehicles.'}) || "User has no associated vehicles."}}</ion-label>
                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>

        <ion-row *ngIf="dataService['settings']['lockers']['enabled'] == '1'">
            <ion-col
                    class="responsive-align"
                    size="10" offset="1" sizeSm="12"
            >
                <h3 class="subheader-regular">
                    {{('keys.data.lockers.active_lockers' | translate : {Default: 'Active Lockers'}) || 'Active Lockers'}}
                </h3>
            </ion-col>
        </ion-row>

        <ion-row *ngIf="activeLockers.length>0 && dataService['settings']['lockers']['enabled'] == '1'">
            <ion-col size="10" offset="1">
                <ion-grid>

                    <ion-row class="swiper-items">
                        <ion-col
                                size-xs="12"
                                size-sm="11"
                                offset-sm="0.5">
                            <swiper
                                #swiper

                                [config]="lockersConfig"
                            >
                                <ng-template *ngFor="let locker of activeLockers" swiperSlide style="text-align: center">
                                    <app-lockers [locker]="locker"></app-lockers>


                                </ng-template>

                            </swiper>

                        </ion-col>
                    </ion-row>

                    <ion-row class="stacked-items">
                        <ion-col *ngFor="let locker of activeLockers"
                                 style="margin: 0.5em 0;padding: 1em;"
                                 size-md="6"
                                 size-lg="4"
                                 size-xl="3">
                            <app-lockers [locker]="locker"></app-lockers>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>

        <ion-row *ngIf="activeLockers.length<1 && dataService['settings']['lockers']['enabled'] == '1'">
            <ion-col size="6" offset="3">
                <ion-card class="card-shadow-3">
                    <ion-card-content style="text-align: center">
                        <ion-label class="paragraph-input-fields-regular"> {{('keys.data.lockers.no_active_lockers' | translate : {Default: "User doesn't have any active lockers"}) || "User doesn't have any active lockers"}}</ion-label>
                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>

        <ion-row *ngIf="activeDeposits.length>0">
            <ion-col size="10" offset="1">
                <ion-grid>
                    <ion-row>
                        <ion-col

                                size="12"
                                class="ion-text-center"
                        >
                            <h3>
                                {{('keys.data.deposits.active_deposits' | translate : {Default: 'Active Deposits'}) || 'Active Deposits'}}

                            </h3>
                        </ion-col>
                    </ion-row>

                    <ion-row class="swiper-items">
                        <ion-col
                                size-xs="12"
                                size-sm="11"
                                offset-sm="0.5">
                            <swiper
                                #swiper

                                [config]="permitsConfig"
                            >
                                <ng-template *ngFor="let deposit of activeDeposits" swiperSlide style="text-align: center">
                                    <app-deposits [deposit]="deposit"></app-deposits>


                                </ng-template>

                            </swiper>

                        </ion-col>
                    </ion-row>
                    <ion-row class="stacked-items">
                        <ion-col style="margin: 0.5em 0;padding: 1em;" *ngFor="let deposit of activeDeposits"
                                 size-md="6"
                                 size-lg="4"
                                 size-xl="3">
                            <app-deposits [deposit]="deposit"></app-deposits>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>
        <ion-row
                *ngIf="standardPermits.length<1 && tempPermits.length<1 && vehiclesSRV.vehicles.length<1 && unpaidViolations.length<1 && activeDeposits.length<1 && activeLockers.length<1"
                style="
       align-items: center;">
            <ion-col>
                <ion-grid>
                    <ion-row>
                        <ion-col style="text-align: center;">
                            <h3 class="ion-text-wrap subheader-regular">
                                Welcome, {{ dataService.user['firstName']}} {{dataService.user['lastName']}}
                            </h3>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col style="text-align: center;">
                            <img src="assets/images/home-page car.png">
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col class="ion-text-center">
                            <h4 class="paragraph-regular">You don’t have active any items yet.
                            </h4>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>

    </ion-grid>


    <ion-grid *ngIf="!loaded">
        <ion-row>
            <ion-col size="10" offset="1">
                <ion-card *ngFor="let x of [0, 1, 2, 3]">
                    <ion-card-header style="text-align: center; font-weight: bold">
                        <ion-title
                        >
                            <ion-skeleton-text
                                    animated
                                    style="width: 60%"
                            ></ion-skeleton-text
                            >
                        </ion-title>
                        <ion-card-subtitle
                        >
                            <ion-skeleton-text
                                    animated
                                    style="width: 60%"
                            ></ion-skeleton-text
                            >
                        </ion-card-subtitle>
                    </ion-card-header>
                    <ion-card-content>
                        <ion-row>
                            <ion-col>
                                <ion-item>
                                    <ion-skeleton-text
                                            animated
                                            style="width: 40%"
                                    ></ion-skeleton-text>
                                </ion-item>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <ion-item>
                                    <ion-skeleton-text
                                            animated
                                            style="width: 40%"
                                    ></ion-skeleton-text>
                                </ion-item>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <ion-item>
                                    <ion-skeleton-text
                                            animated
                                            style="width: 40%"
                                    ></ion-skeleton-text>
                                </ion-item>
                            </ion-col>
                        </ion-row>
                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>
    </ion-grid>
    <ion-footer class="ion-no-border">
        <app-footer></app-footer>
    </ion-footer>
</ion-content>
